import { render, staticRenderFns } from "./InitialStatusSelector.vue?vue&type=template&id=e038cf3c&scoped=true&"
import script from "./InitialStatusSelector.vue?vue&type=script&lang=js&"
export * from "./InitialStatusSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e038cf3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
